import styled from "@emotion/styled";

import { fontRobotoCondensed } from "shared/lib/styles";

import { AdSlot } from "scmp-app/components/advertisement/ad-slots/ad-slot";

export const StyledAdSlot = styled(AdSlot)`
  align-items: flex-start;

  block-size: unset;
`;

export const Container = styled.div``;

export const Title = styled.div`
  padding-block-end: 4px;

  color: #333333;
  font-weight: 500;
  font-size: 12px;
  font-family: ${fontRobotoCondensed};
  font-style: normal;
  line-height: normal;
  text-transform: uppercase;
`;
